import { render, staticRenderFns } from "./AgendaManage.vue?vue&type=template&id=00bd2dff&scoped=true"
import script from "./AgendaManage.vue?vue&type=script&lang=js"
export * from "./AgendaManage.vue?vue&type=script&lang=js"
import style0 from "./AgendaManage.vue?vue&type=style&index=0&id=00bd2dff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bd2dff",
  null
  
)

export default component.exports